var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72487 9.29989C1.63595 8.29133 1.69467 7.27578 1.89935 6.28428C2.17309 5.04952 2.71078 4.02446 3.49705 3.23847C4.59872 2.13597 6.14804 1.53172 8.0961 1.44225C9.03979 1.40674 9.98459 1.47133 10.9143 1.63434L11.162 0.225939C10.1306 0.0450306 9.08257 -0.0262703 8.03626 0.0137141C5.71493 0.120805 3.8474 0.865411 2.48625 2.22768C1.50314 3.21051 0.835425 4.47268 0.502408 5.98062C0.501849 5.98342 0.50101 5.9865 0.500451 5.98929C0.266136 7.11892 0.199309 8.27651 0.300808 9.42544L1.72487 9.29989Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86062 18.642C4.43002 17.8563 4.03521 17.0667 3.68681 16.2944L2.38354 16.8824C2.74704 17.688 3.15863 18.5114 3.60712 19.3293L4.86062 18.642Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.717041 12.0624C0.896272 12.8282 1.11409 13.5848 1.36965 14.3289L2.72269 13.8667C2.48279 13.1682 2.27783 12.4583 2.10979 11.7397L0.717041 12.0624Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.444 26.5156C10.3816 26.4443 10.3195 26.3735 10.2577 26.3022L9.17871 27.2398C9.2419 27.3128 9.30537 27.3857 9.36969 27.4587C9.73262 27.872 10.1104 28.2886 10.4926 28.6974C10.664 28.8803 10.8371 29.0628 11.0121 29.2446L12.0425 28.2534C11.8719 28.0764 11.7033 27.8988 11.537 27.7207C11.1645 27.3228 10.7971 26.9171 10.444 26.5156Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45141 25.1391L8.57993 24.2617C8.47619 24.1281 8.37357 23.9944 8.27179 23.8602C7.83644 23.2875 7.41506 22.7062 7.01969 22.1328L5.84253 22.9442C6.25076 23.5361 6.685 24.1353 7.1335 24.725C7.23807 24.8634 7.34432 25.0013 7.45141 25.1391Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.228 30.4687C13.5788 31.7868 15.0001 33.0305 16.4857 34.1939C18.5006 35.7796 20.651 37.1849 22.9125 38.3929C24.2334 39.0961 25.6024 39.7051 27.0088 40.2157L25.7031 40.5895L26.0962 41.9641L29.7518 40.918C30.1313 40.8095 30.3508 40.4136 30.2423 40.0339L29.2896 36.7043L27.9148 37.0974L28.5204 39.2127C26.8134 38.6725 25.1606 37.9754 23.583 37.1301C21.3962 35.9619 19.3167 34.603 17.3687 33.0696C15.9234 31.9378 14.5404 30.7279 13.2262 29.4459L12.228 30.4687Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5163 30.7024C41.2244 28.8788 40.6213 26.917 39.7235 24.8716L38.4143 25.4462C39.2632 27.3803 39.8317 29.2252 40.1043 30.928C40.616 34.1251 40.054 36.6469 38.4795 38.222C37.6996 39.0018 36.6855 39.5364 35.465 39.8116C34.4782 40.0336 33.3595 40.0864 32.139 39.9695C31.8382 39.9407 31.5278 39.9008 31.2163 39.8516L30.9932 41.2636C31.3326 41.3173 31.6723 41.3606 32.0026 41.3925C32.4676 41.437 32.9205 41.4593 33.3615 41.4593C34.1743 41.4644 34.9852 41.3791 35.7793 41.206C37.2679 40.8702 38.5164 40.2064 39.4903 39.2325C41.4025 37.3202 42.103 34.3709 41.5163 30.7024Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0499 21.5612L36.8079 22.2691C37.1521 22.8731 37.4767 23.4815 37.7728 24.0774L39.0534 23.4418C38.7456 22.8211 38.4081 22.1886 38.0499 21.5612Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7322 16.5916L33.5964 17.4601C34.1294 18.1572 34.6495 18.8772 35.143 19.6011L36.3246 18.7961C35.8163 18.0506 35.2805 17.3088 34.7322 16.5916Z",
    fill: "url(#paint8_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1988 12.4597L30.165 13.4467C30.7701 14.0806 31.366 14.7402 31.9358 15.4065L33.0224 14.4774C32.4355 13.7915 31.822 13.1126 31.1988 12.4597Z",
    fill: "url(#paint9_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1378 5.03021L14.5358 4.73131L14.0742 2.57187C15.3861 3.03714 16.6629 3.59776 17.8934 4.24842C20.0517 5.38811 22.1063 6.71403 24.0331 8.21219C24.9416 8.91317 25.8568 9.674 26.7529 10.4728C27.2498 10.9166 27.7503 11.3813 28.2402 11.8544C28.4524 12.0594 28.6691 12.2727 28.8849 12.488L29.8957 11.4772C29.6743 11.256 29.4517 11.0368 29.2331 10.826C28.7303 10.34 28.2161 9.86246 27.7053 9.40585C26.7837 8.58463 25.8422 7.802 24.9092 7.082C24.0004 6.37542 23.0595 5.70603 22.0943 5.07243C22.6426 4.76318 23.1935 4.47043 23.7328 4.20228L23.0967 2.92194C22.4553 3.24014 21.8004 3.59077 21.1506 3.96321L21.6047 4.75563C20.6132 4.12399 19.5991 3.53373 18.5617 2.98429C17.6376 2.49637 16.6894 2.0571 15.72 1.66732L16.9797 1.39834L16.6816 0L12.9636 0.794656C12.5774 0.877141 12.3314 1.25685 12.4139 1.643L13.1378 5.03021Z",
    fill: "url(#paint10_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.225785 30.8143C0.0448767 31.8458 -0.0264243 32.8937 0.0138398 33.94C0.120372 36.2611 0.864977 38.1283 2.22752 39.4903C3.21036 40.4735 4.47336 41.1406 5.98047 41.4733C5.98327 41.4736 5.98634 41.4745 5.9897 41.475C6.77764 41.6386 7.58097 41.7211 8.38625 41.7211C8.73269 41.7211 9.07912 41.706 9.42528 41.6755L9.29974 40.2509C8.29118 40.3404 7.27535 40.2814 6.28413 40.0761C5.04908 39.8032 4.02431 39.2661 3.23832 38.4795C2.13609 37.3773 1.53157 35.8277 1.4421 33.8802C1.40658 32.9362 1.47062 31.9917 1.63419 31.0614L0.225785 30.8143Z",
    fill: "url(#paint11_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8829 39.5926C17.6891 39.2294 18.5122 38.8172 19.3295 38.3693L18.6428 37.1158C17.8574 37.5461 17.0675 37.9412 16.2949 38.2893L16.8829 39.5926Z",
    fill: "url(#paint12_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0619 41.2598C12.8281 41.0805 13.5847 40.8627 14.3285 40.6072L13.8663 39.2538C13.1681 39.494 12.4581 39.6984 11.7393 39.867L12.0619 41.2598Z",
    fill: "url(#paint13_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3027 31.7186L27.2397 32.7984C27.313 32.7353 27.3859 32.6715 27.4592 32.6072C27.8728 32.2437 28.2897 31.8654 28.6979 31.4843C28.8807 31.3129 29.0633 31.1398 29.2454 30.9645L28.2539 29.9344C28.0769 30.1052 27.8993 30.2733 27.7209 30.4399C27.3236 30.8115 26.9182 31.1792 26.5155 31.5326C26.4448 31.595 26.374 31.6571 26.3027 31.7186Z",
    fill: "url(#paint14_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1333 34.9565L22.9447 36.1339C23.5367 35.7262 24.1359 35.2917 24.7259 34.8432C24.864 34.7384 25.0018 34.6324 25.1397 34.5253L24.2623 33.3962C24.1289 33.5 23.995 33.6029 23.861 33.7049C23.2881 34.1403 22.7073 34.5614 22.1333 34.9565Z",
    fill: "url(#paint15_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9277 1.87115C34.1245 1.36002 36.6466 1.92176 38.2217 3.49653C39.0009 4.27581 39.5358 5.29024 39.8113 6.51074C40.033 7.49777 40.0864 8.61677 39.969 9.837C39.9404 10.1373 39.901 10.4474 39.8512 10.7594L41.2633 10.9828C41.317 10.6423 41.3603 10.3026 41.3922 9.97345C41.5236 8.60251 41.461 7.33196 41.2057 6.19674C40.8701 4.70808 40.2063 3.45906 39.2325 2.48517C37.3199 0.572911 34.3697 -0.127795 30.7021 0.459389C28.8793 0.751024 26.917 1.35442 24.8713 2.25198L25.4459 3.5614C27.38 2.7125 29.2243 2.14377 30.9277 1.87115Z",
    fill: "url(#paint16_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4056 10.0409L14.4761 8.95459C13.7903 9.54149 13.1116 10.155 12.4587 10.7774L13.446 11.8117C14.0802 11.2063 14.7398 10.6104 15.4056 10.0409Z",
    fill: "url(#paint17_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6015 6.83313L18.796 5.65149C18.0505 6.1601 17.3087 6.69584 16.5918 7.24388L17.4603 8.37966C18.1565 7.847 18.8771 7.32664 19.6015 6.83313Z",
    fill: "url(#paint18_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9178 12.2251C40.8093 11.8454 40.4134 11.6259 40.034 11.7344L36.7041 12.6873L37.0972 14.0619L39.2127 13.4565C38.6722 15.1633 37.9749 16.8163 37.1296 18.3939C35.9614 20.5807 34.6025 22.6602 33.0691 24.6083C31.937 26.0536 30.7274 27.4363 29.4451 28.7504L30.4682 29.7489C31.7863 28.3981 33.0297 26.9768 34.1934 25.4913C35.7791 23.4767 37.1844 21.3259 38.3924 19.0644C39.0953 17.7432 39.7046 16.3748 40.2151 14.9681L40.589 16.2739L41.9636 15.8807L40.9178 12.2251Z",
    fill: "url(#paint19_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49368 29.2337C1.54374 29.2337 1.59407 29.2284 1.64356 29.2175L5.03021 28.4938L4.73131 27.0955L2.57215 27.5574C3.03742 26.2452 3.59776 24.9688 4.2487 23.7382C5.38784 21.5796 6.71431 19.525 8.21219 17.5982C8.9129 16.69 9.67372 15.7749 10.4729 14.8784C10.9166 14.3813 11.3813 13.8811 11.8544 13.3915C12.0616 13.177 12.2747 12.96 12.4883 12.7464L11.4775 11.7356C11.2583 11.9548 11.0391 12.1774 10.8263 12.398C10.34 12.9013 9.86246 13.4152 9.40585 13.9266C8.5838 14.848 7.80172 15.7897 7.082 16.7225C5.53351 18.715 4.1623 20.8383 2.98457 23.0699C2.49637 23.9935 2.05682 24.9419 1.6676 25.9116L1.39834 24.6511L0 24.9498L0.794656 28.6677C0.865118 28.9977 1.15647 29.2331 1.49368 29.2337Z",
    fill: "url(#paint20_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8171 15.3179V26.6584C14.8171 27.2635 15.1566 28.1155 16.8779 28.7382C17.9924 29.1414 19.4495 29.3637 20.9968 29.3637H21.0522C21.9461 29.3637 22.8381 29.282 23.7172 29.1201C25.9457 28.6926 27.2378 27.7953 27.2378 26.6584V15.3179C27.2378 14.7126 26.8594 13.8612 25.1379 13.2379C24.0231 12.8347 22.5464 12.6124 20.9971 12.6124C19.4472 12.6124 17.9969 12.8347 16.8821 13.2379C15.1608 13.8609 14.8171 14.7126 14.8171 15.3179ZM23.4496 27.7151C22.6407 27.865 21.8197 27.9382 20.9974 27.934C19.6086 27.934 18.331 27.7419 17.3686 27.3941C16.4271 27.0532 16.2468 26.7116 16.2468 26.6584V24.6631C16.4501 24.7708 16.6612 24.8636 16.8779 24.9405C17.9924 25.344 19.4495 25.566 20.9996 25.566C22.5501 25.566 24.0292 25.344 25.1437 24.9405C25.3881 24.8521 25.54 24.759 25.8081 24.6626V26.6581C25.8081 26.7924 25.2293 27.3737 23.4496 27.7151ZM25.8081 22.8605C25.8081 22.9142 25.5931 23.2556 24.6519 23.5964C23.6892 23.9448 22.3859 24.1363 20.9971 24.1363C19.6086 24.1363 18.331 23.9448 17.3686 23.5964C16.4271 23.2556 16.2468 22.9139 16.2468 22.8605V20.8914C16.4501 20.9994 16.6612 21.0922 16.8779 21.1691C17.9924 21.5726 19.4495 21.7946 20.9996 21.7946C22.5501 21.7946 24.0292 21.5726 25.1437 21.1691C25.3881 21.0807 25.54 20.9876 25.8081 20.8914V22.8605ZM24.6519 19.8247C23.6892 20.1731 22.3859 20.3647 20.9971 20.3647C19.6086 20.3647 18.331 20.1731 17.3686 19.8247C16.4271 19.4842 16.2468 19.1425 16.2468 19.0893V17.1198C16.4503 17.2274 16.6612 17.3202 16.8779 17.3974C17.9927 17.8009 19.4497 18.0229 20.9996 18.0229C22.5495 18.0229 24.0289 17.8006 25.1437 17.3974C25.3881 17.3088 25.54 17.2157 25.8081 17.1198V19.0893C25.8081 19.1425 25.5931 19.4842 24.6519 19.8247ZM17.3426 14.5823C18.3053 14.2336 19.6002 14.0421 20.9884 14.0421C22.3764 14.0421 23.6716 14.2336 24.6343 14.5823C25.5752 14.9231 25.7734 15.2645 25.7734 15.3179C25.7734 15.3708 25.5752 15.7122 24.6343 16.053C23.6716 16.4017 22.3764 16.5933 20.9884 16.5933C19.6002 16.5933 18.3053 16.4012 17.3426 16.053C16.4011 15.7122 16.2032 15.3708 16.2032 15.3179C16.2032 15.2645 16.4014 14.9231 17.3429 14.5823H17.3426Z",
    fill: "url(#paint21_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.68877,
    y1: 9.42544,
    x2: 5.68877,
    y2: 0.00292929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 3.61761,
    y1: 19.3293,
    x2: 3.61761,
    y2: 16.2944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1.71625,
    y1: 14.3289,
    x2: 1.71625,
    y2: 11.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.6054,
    y1: 29.2446,
    x2: 10.6054,
    y2: 26.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 7.20629,
    y1: 25.1391,
    x2: 7.20629,
    y2: 22.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 21.2164,
    y1: 41.9641,
    x2: 21.2164,
    y2: 29.4459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 36.3361,
    y1: 41.4595,
    x2: 36.3361,
    y2: 24.8716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 37.9266,
    y1: 24.0774,
    x2: 37.9266,
    y2: 21.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 34.9556,
    y1: 19.6011,
    x2: 34.9556,
    y2: 16.5916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 31.5886,
    y1: 15.4065,
    x2: 31.5886,
    y2: 12.4597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 21.1153,
    y1: 12.488,
    x2: 21.1153,
    y2: -5.22145e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 4.6971,
    y1: 41.7211,
    x2: 4.6971,
    y2: 30.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 17.8068,
    y1: 39.5926,
    x2: 17.8068,
    y2: 37.1158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 13.0292,
    y1: 41.2598,
    x2: 13.0292,
    y2: 39.2538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 27.7687,
    y1: 32.7984,
    x2: 27.7687,
    y2: 29.9344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 23.6311,
    y1: 36.1339,
    x2: 23.6311,
    y2: 33.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 33.1352,
    y1: 10.9828,
    x2: 33.1352,
    y2: 0.25769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 13.9268,
    y1: 11.8117,
    x2: 13.9268,
    y2: 8.95459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 18.0912,
    y1: 8.37966,
    x2: 18.0912,
    y2: 5.65149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 35.6817,
    y1: 29.7489,
    x2: 35.6817,
    y2: 11.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 6.2216,
    y1: 29.2337,
    x2: 6.2216,
    y2: 11.7356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 21.005,
    y1: 29.3637,
    x2: 21.005,
    y2: 12.6124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScience);
export default __webpack_public_path__ + "static/media/data_science.11bfaa049eb174964e64da6bc526ba22.svg";
export { ForwardRef as ReactComponent };